import { useState } from "react";
import Segmented from "@/components/Segmented";
import { useEscritorioInfo, gravarEscopo, lerEscopo } from "@/lib/escritorioInfo";

// Lote 157 — "Minha pauta | Escritório" (+ filtro por pessoa). Só aparece para quem faz parte de um escritório.
// "Minha pauta" = o que tem VOCÊ como responsável (mesmo que esteja na conta de outra pessoa); "Escritório" = de todos.
// A escolha vale para Processos e Agenda e fica lembrada neste aparelho.
export function useEscopo() {
  const [v, setV] = useState(lerEscopo);
  const mudar = (novo) => { setV(novo); gravarEscopo(novo); };
  return [v, mudar];
}

export default function EscopoPauta({ valor, onChange, className = "" }) {
  const info = useEscritorioInfo(true);
  const pessoas = (info?.membros || []).filter((m) => m.papel !== "apoio");
  const extras = (info?.ex_membros || []);
  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`} data-testid="escopo-pauta">
      <Segmented size="sm" fit testid="escopo-seletor" ariaLabel="Qual pauta mostrar" value={valor.escopo}
        onChange={(k) => onChange({ escopo: k, responsavel: k === "minha" ? "" : valor.responsavel })}
        options={[{ key: "minha", label: "Minha pauta", testid: "escopo-minha" }, { key: "escritorio", label: "Escritório", testid: "escopo-escritorio" }]} />
      {valor.escopo === "escritorio" && (
        <label className="inline-flex items-center gap-2 text-xs text-stone-500">
          Responsável
          <select data-testid="escopo-pessoa" value={valor.responsavel} onChange={(e) => onChange({ escopo: "escritorio", responsavel: e.target.value })}
            className="h-9 rounded-md border border-stone-300 bg-white px-2 text-sm text-stone-900">
            <option value="">Todos</option>
            {pessoas.map((m) => <option key={m.user_id} value={m.user_id}>{m.nome}{m.eu ? " (você)" : ""}</option>)}
            {extras.map((m) => <option key={m.user_id} value={m.user_id}>{m.nome} (saiu)</option>)}
          </select>
        </label>
      )}
    </div>
  );
}
